/**
 * Validation function for S3-compliant clip names.
 * Uses strict AWS S3 safe character set.
 *
 * Based on AWS S3 safe characters:
 * https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html
 *
 * Rules:
 * - Alphanumeric characters (0-9, a-z, A-Z)
 * - Spaces
 * - AWS S3 safe special characters: ! - _ . * ' ( )
 * - Must contain at least one alphanumeric character
 * - Cannot be empty or whitespace-only
 */
export const validateClipName = (name: string): string | null => {
  if (!name || !name.trim()) {
    return "Clip name cannot be empty";
  }

  // Pattern: AWS S3 safe characters only
  if (!/^[a-zA-Z0-9 !\-_.*'()]+$/.test(name)) {
    return "Only letters, numbers, spaces, and the following special characters are allowed: ! - _ . * ' ( )";
  }

  // Prevent names that are only whitespace/punctuation
  if (!/[a-zA-Z0-9]/.test(name)) {
    return "Clip name must contain at least one letter or number";
  }

  return null;
};
